import React from "react";
import Layout from "../components/Layout";
import CustomScrollbar from "../components/Misc/CustomScrollbar";
import Private from "../components/Auth/Private";
import UnderDevelopment from "../components/Misc/UnderDevelopment";
import SEO from "../components/Misc/SEO";

const messages = () => {
  return (
    <Layout>
      <SEO title="Explore" />
      <Private>
        <div className="inner-content w-100">
          <CustomScrollbar page={true}>
            <UnderDevelopment />
          </CustomScrollbar>
        </div>
      </Private>
    </Layout>
  );
};

export default messages;
